import {channelActionType} from '../actions/actionType' 
const initialState ={
    zipcodeData: {},
    allPackageData:{},
    searchChannelData: {},
    compareChannelData:{},
    packageViewByNameData: {},
    actionData:{}
} 


function channelReducer(state=initialState, action){
    switch(action.type){
        case channelActionType.zipCodeSuccess:
            return Object.assign({}, state,{
                zipcodeData: action.value
            })
        case channelActionType.allPackageSuccess:
            return Object.assign({}, state,{
                allPackageData: action.value
            })
        case channelActionType.searchChannelSuccess:
            return Object.assign({}, state,{
                searchChannelData: action.value
            })
        case channelActionType.compareChannelSuccess:
            return Object.assign({}, state,{
                compareChannelData: action.value
            })
        case channelActionType.packageViewByNameSuccess:
            return Object.assign({}, state,{
                packageViewByNameData: action.value
            })
        case channelActionType.loaderSuccess:
            return Object.assign({}, state,{
                actionData: action.value
            })
        default:
            return state;
    }
}

export default channelReducer

